import * as React from "react"
const SvgDashboard = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10.45 16.071q.6.6 1.55.588t1.4-.688l4.225-6.325q.226-.35-.063-.637-.287-.288-.637-.063L10.6 13.171q-.675.45-.713 1.375-.036.925.563 1.525M12 4.571q.9 0 1.775.15t1.7.475q.4.15.85.563t.25.787c-.2.375-.433.417-.9.5q-.7.126-1.125-.025a7.4 7.4 0 0 0-2.55-.45q-3.325 0-5.662 2.338Q4 11.247 4 14.57q0 1.05.287 2.075A8.2 8.2 0 0 0 5.1 18.57h13.8a7.3 7.3 0 0 0 .838-1.975A8.5 8.5 0 0 0 20 14.471a7 7 0 0 0-.45-2.5 1.4 1.4 0 0 1-.05-.825q.1-.399.45-.675a.79.79 0 0 1 .713-.15.76.76 0 0 1 .537.45 9.9 9.9 0 0 1 .8 3.65 9.8 9.8 0 0 1-.325 2.725 10.4 10.4 0 0 1-1.025 2.475q-.274.45-.75.7-.475.25-1 .25H5.1q-.525 0-1-.25a1.9 1.9 0 0 1-.75-.7A9.9 9.9 0 0 1 2 14.571q0-2.075.788-3.887a10.2 10.2 0 0 1 2.15-3.175 10.1 10.1 0 0 1 3.187-2.15A9.7 9.7 0 0 1 12 4.57Z" />
  </svg>
)
export default SvgDashboard
